import React, { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './Paginas/Home';
import SenhaReset from './Paginas/SenhaReset';
import AcessoLink from './Paginas/AcessoLink';
import Wellcome from './Paginas/Privadas/Wellcome';
import DashboardGeral from './Paginas/GeneralDashboard';
import Potenciometro from './Animação/Potenciometro';
import Paginas from './Funções/Paginas';
import Init from './Funções/Init';
import CorpoPagina from './Componentes/CorpoPagina';
import { StoreContexto } from './Contexto/Provider';
import DashboardGeneral from './Paginas/GeneralDashboard';

function App() {
  const { auth, isInitialized } = useContext(StoreContexto);

  const renderProtectedRoute = (element) => (auth.token ? element : <Navigate to="/" replace />);

  if (isInitialized) {
    return (
      <div>
        <Routes>
          <Route path="/anim" element={<Potenciometro />} />
          <Route path={`${Init.prefix}/`} element={<Home />} />
          <Route path={`${Init.prefix}/ResetPassword`} element={<SenhaReset />} />
          <Route path={`${Init.prefix}/DashboardView`} element={<DashboardGeneral />} />
          <Route path={`${Init.prefix}/Recover/:link`} element={<AcessoLink />} />
          <Route path={`${Init.prefix}/home`} element={renderProtectedRoute(<DashboardGeral />)} />

          {Paginas.map((item, index) => (
            <Route key={index} path={item.caminho} element={renderProtectedRoute(item.elemento)} />
          ))}

          <Route path="*" element={auth.token ? <Wellcome /> : <Navigate to="/" replace />} />
        </Routes>
      </div>
    );
  } else {
    return <CorpoPagina loading={true}></CorpoPagina>;
  }
}

export default App;
